import { patientAssessmentsClient } from '@/api/patients/patientAssessmentsClient';
import { QueryKey } from '@/data/query';
import type { PatientAssessmentDto } from '@montugroup/pms-api-contracts';

const queryClient = patientAssessmentsClient();

export type PatientAssessment = PatientAssessmentDto;

export const useGetPatientAssessments = (patientId: number | undefined) => {
  const queryResult = queryClient.getPatientAssessment.useQuery({
    queryKey: [QueryKey.GetPatientAssessments, patientId],
    queryData: {
      params: { id: Number(patientId) }
    },
    enabled: Boolean(patientId)
  });
  return {
    data: queryResult.data?.body?.data?.attributes ?? null,
    isError: queryResult.isError,
    isLoading: queryResult.isLoading,
    refetch: queryResult.refetch
  };
};
